import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";
import { EmployeeStatus, Gender } from "../../model";

export class EmployeeDTO {
    constructor(props: EmployeeDTO) {
        safeAssign<EmployeeDTO>(this, props);
    }

    @Expose() id: number;
    @Expose() staffNumber: number;
    @Expose() firstName: string;
    @Expose() lastName: string;
    @Expose() title: string;
    @Expose() callName: string;
    @Expose() address: string;
    @Expose() city: string;
    @Expose() postalCode: string;
    @Expose() email: string;
    @Expose() phone: string;
    @Expose() phone2: string;
    @Expose() birthday: string;
    @Expose() birthName: string;
    @Expose() birthCountry: string;
    @Expose() nationality: string;
    @Expose() gender?: Gender;
    @Expose() notes: string;
    @Expose() avatar: string;
    @Expose() status: EmployeeStatus;
    @Expose() timePin: string;
}
